var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"d-flex justify-content-center mb-3"},[_c('b-spinner',{staticStyle:{"width":"7rem","height":"7rem"},attrs:{"variant":"primary","label":"Loading..."}})],1),_c('p',{staticClass:"animate-flicker"},[_vm._t("default",function(){return [_vm._v("Loading . . . ")]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }